import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {deleteCompanyBranchForm} from "../store/actions/companyBranchForm";
import {Alert, Button, Spinner} from "reactstrap";


type CompanyBranchDeleteType = {
    deleteCompanyBranchForm: (sectionId:number, id: number) => void
    cancelHandler?: () => void
    id: number
    sectionId: number
    changeLoading: boolean
    changeError: string
}

class CompanyBranchDeleteContainer extends Component<CompanyBranchDeleteType> {

    deleteHandler = () =>{
        const {id, deleteCompanyBranchForm, sectionId} = this.props;
        deleteCompanyBranchForm(sectionId, id)
    };

    render() {
        const {changeLoading, changeError, cancelHandler} = this.props;

        return (
            <>
                {changeError &&
                (<Alert className={'mt-3'} color={'danger'}>
                    {changeError}
                </Alert>)}
                <div className={'text-right'}>
                    {cancelHandler && <Button onClick={cancelHandler} color={'primary'} className={'mr-3'}>Не удалять</Button>}
                    <Button onClick={this.deleteHandler} color={'danger'} disabled={changeLoading}>
                        {changeLoading &&
                        (<Spinner

                            size="sm"
                        />)}
                        Да, удалить
                    </Button>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: AppState) => {
    const {changeLoading, changeError} = state.companyBranchForm;

    return {
        changeLoading,
        changeError
    }
};

const mapDispatchToProps = {
    deleteCompanyBranchForm
};


export default connect(mapStateToProps, mapDispatchToProps)(CompanyBranchDeleteContainer);
